interface FiAgeSummaryInput {
  fiYear: number | null | undefined;
  primaryName: string | null | undefined;
  primaryFiAge: number | null | undefined;
  spouseName?: string | null | undefined;
  spouseFiAge?: number | null | undefined;
}

/**
 * Shared copy for the FIRE Plan hero: returns a sentence describing FI for
 * one or both household members. Falls back to the year or a generic label
 * when ages aren't available.
 */
export function formatFiAgeSummary({
  fiYear,
  primaryName,
  primaryFiAge,
  spouseName,
  spouseFiAge,
}: FiAgeSummaryInput): string {
  if (!fiYear) return 'No FI age yet';
  if (primaryFiAge) {
    if (primaryName && spouseName && spouseFiAge) {
      return primaryFiAge === spouseFiAge
        ? `FI when ${primaryName} and ${spouseName} are ${primaryFiAge}`
        : `FI when ${primaryName} is ${primaryFiAge}, ${spouseName} is ${spouseFiAge}`;
    }
    return primaryName
      ? `FI when ${primaryName} is ${primaryFiAge}`
      : `FI at age ${primaryFiAge}`;
  }
  return `FI in ${fiYear}`;
}
